import { useSubscriptionBlocks } from './useSubscriptionBlocks';

/**
 * True when the organization holds exactly one subscription over exactly one store.
 *
 * Those organizations skip the list and land on the detail, so the list redirects and the detail
 * stops linking back. The subscription status is deliberately left out: a single churned
 * subscription still goes straight in.
 */
export const useIsSingleStoreOrganization = (): boolean => {
  const { data: blocks } = useSubscriptionBlocks();

  return blocks?.length === 1 && blocks[0].stores.length === 1;
};
